
import { Component, Vue } from "vue-property-decorator";

@Component
export default class BodyConfigImportexportElement extends Vue {
  show: boolean = false;
  showCopyJsonTooltip: boolean = false;
  showCopyUrlTooltip: boolean = false;
  showImportTooltip: boolean = false;
  portType: string = "";
  importConfig: string = "";
  importResult: string = "";
  importFile: File|null = null;

  get config() {
    return this.$store.getters["config/getConfig"]()
  }

  get urlExport() {
    return `${window.location.href.replace(/#.*$/, "")}#config=${encodeURIComponent(JSON.stringify(this.config))}`
  }

  get jsonExport() {
    return JSON.stringify(
      this.config,
      undefined,
      2
    );
  }

  showWithType(type: string) {
    this.portType = type;
  }

  cancel() {
    this.show = false;
  }

  copyJsonExport() {
    navigator.clipboard.writeText(this.jsonExport)
      .then(() => {
        this.showCopyJsonTooltip = true;
        setTimeout(
          function (scope: any) {
            scope.showCopyJsonTooltip = false;
          },
          1000,
          this
        );
      })
  }

  copyUrl() {
    navigator.clipboard.writeText(this.urlExport)
      .then(() => {
        this.showCopyUrlTooltip = true;
        setTimeout(
          function (scope: any) {
            scope.showCopyUrlTooltip = false;
          },
          1000,
          this
        );
      })
  }

  downloadJsonExport() {
    const file_data = this.jsonExport;
    const blob = new Blob([file_data], { type: "application/json" });
    const e = new MouseEvent("click", {bubbles: true});
    let a = document.createElement("a");
    a.download = "global-config.json";
    a.href = window.URL.createObjectURL(blob);
    a.dataset.downloadurl = ["application/json", a.download, a.href].join(":");
    a.dispatchEvent(e);
  }

  configImport() {
    let importObj = {};

    this.showImportTooltip = false;
    try {
      importObj = JSON.parse(this.importConfig.replaceAll("\n", ""));
    } catch {
      this.importResult = "Error: wrong format";
      this.showImportTooltip = true;
      return;
    }

    let requiredKeys = ["bookmarks", "layouts", "activeLayoutIndex"];
    let givenKeys = Object.keys(importObj);
    for (let k of givenKeys) {
      if (requiredKeys.indexOf(k) >= 0) requiredKeys.splice(requiredKeys.indexOf(k), 1);
    }

    if (requiredKeys.length > 0) {
      this.importResult = `Error: config keys (${requiredKeys.join(', ')}) missing`;
      this.showImportTooltip = true;
      return;
    }

    this.$store.dispatch("config/updateAllConfig", importObj);
    this.importResult = "Successful!";
    this.showImportTooltip = true;
  }

  uploadConfig() {
    if (!this.importFile || this.importFile === null) {
      this.importResult === "";
      this.showImportTooltip = false;
      return
    };
    if (!(this.importFile.type === "application/json")) {
      this.importResult = "Upload failed!";
      this.showImportTooltip = true;
      return
    }
    this.importFile.text().then(data => {
      this.importConfig = data;
    }).catch(() => {
      this.importResult = "Upload failed!";
      this.showImportTooltip = true;
    });
  }
}
